import { dispatch } from 'AppStore/index'
import * as ActionTypes from 'AppActions/types'

export const toggleModal = () => {
  dispatch ({
    type: ActionTypes.TOGGLE_MODAL
  })
}